// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0d7b2179","239":"35be9ccd","453":"ca8e2816","732":"ebf18476"}[chunkId] + ".chunk.js";
};